import { defineStore } from 'pinia';
import { readonly, ref, computed } from 'vue';
import { getTodos, type TodoItem } from '@/js/lib/api/todo';

export const useTodoStore = defineStore('todo', () => {
  const isLoaded = ref(false);
  const todos = ref<TodoItem[]>([]);
  const totalCount = ref(0);

  async function loadTodos() {
    try {
      const res = await getTodos();
      todos.value = res.todos;
      totalCount.value = res.totalCount;
    } catch {
      todos.value = [];
      totalCount.value = 0;
    } finally {
      isLoaded.value = true;
    }
  }

  return {
    isLoaded: readonly(isLoaded),
    todos: readonly(todos),
    totalCount: computed(() => Number(totalCount.value)),
    loadTodos,
  };
});
